/**
 * GiftCardCreateModal — the form staff use to issue a gift card by hand.
 * On success it opens the new card, carrying whether the recipient's email
 * went out so the details page can say so.
 */
import { Field } from '../dashboards/primitives/Field';
import { fieldStyle } from '../dashboards/primitives/field-style';
import { PriceInput } from '../dashboards/primitives/PriceInput';
import { SimpleModal } from '../shared/SimpleModal';

import { useGiftCardCreate } from './use-gift-card-create';

export function GiftCardCreateModal({ onClose }: { onClose: () => void }) {
  const { values, errors, submitError, submitting, set, submit } = useGiftCardCreate();

  return (
    <SimpleModal
      open
      onClose={() => {
        if (!submitting) onClose();
      }}
      title="Create gift card"
    >
      <form
        onSubmit={submit}
        noValidate
        style={{ display: 'flex', flexDirection: 'column', gap: 14 }}
      >
        <Field label="Amount" required error={errors.amount} linkControl={false}>
          <PriceInput
            value={values.amount}
            ariaLabel="Amount in dollars"
            required
            error={errors.amount}
            onChange={set('amount')}
          />
        </Field>
        <Field label="Recipient email" required error={errors.recipientEmail}>
          <input
            type="email"
            value={values.recipientEmail}
            onChange={(e) => set('recipientEmail')(e.target.value)}
            style={fieldStyle(errors.recipientEmail ? 'error' : undefined)}
          />
        </Field>
        <Field label="Reason" required error={errors.reason}>
          <textarea
            value={values.reason}
            rows={3}
            onChange={(e) => set('reason')(e.target.value)}
            style={fieldStyle(errors.reason ? 'error' : undefined, {
              height: 'auto',
              padding: '8px 10px',
            })}
          />
        </Field>
        {submitError && (
          <p role="alert" style={{ margin: 0, fontSize: 12.5, color: 'var(--nb-risk)' }}>
            {submitError}
          </p>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button
            type="button"
            className="nb-btn nb-btn-ghost"
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button type="submit" className="nb-btn nb-btn-primary" disabled={submitting}>
            {submitting ? 'Creating…' : 'Create gift card'}
          </button>
        </div>
      </form>
    </SimpleModal>
  );
}
